import React, { Component } from "react";
import { connect } from "react-redux";
import LayoutWrap from "../Component/LayoutWrap";
import { dashboardActions } from "../../../_actions";
import * as XLSX from "xlsx";
// import ViewDetails from "./Component/ViewDetails";
// import ViewMailReplies from "./Component/ViewMailReplies";
// import ViewLogs from "./Component/ViewLogs";
import { ActivitiesContent } from './Component/ActivityTabs';
import { EmailsContent } from './Component/EmailsContent';
import { ActivityLogsContent } from './Component/ActivityLogsContent';
import { PDFFilesContent } from './Component/PDFFilesContent';
import { LuArrowLeft } from 'react-icons/lu';
import moment from 'moment';
import PrintMailModal from "./Component/PrintMailModal";

class AssignTask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crrAssignedId: this.props.match.params.id,
      activeTab: 'Activities', // Set 'Activities' as default tab
      employees: [],
      showAssignModal: false,
      showUpdateModal: false,
      step: 1,
      assignFormData: {
        surveyId: "",
        caseStudyId: "",
        rolePlayId: "",
        mailIdList: [],
        employeeId: ""
      }
    };
  }

  componentDidMount() {
    const dataX = {
      assignedId: this.state.crrAssignedId
    }
    this.props.dispatch(dashboardActions.getInsightSurveyByAssignedId(dataX));
    this.props.dispatch(dashboardActions.getInsightEmpTaskById(dataX));
    this.props.dispatch(dashboardActions.getInsightUploadsByAssignedId(dataX));
  }

  handleTabClick = (tabName) => {
    this.setState({ activeTab: tabName });
  };

  openPrintModal = () => {
    this.setState({ showPrintModal: true });
  }

  closeModal = () => {
    this.setState({ showPrintModal: false });
  }

  renderContent = (statusData, uploadX, surveyAns) => {

    let userDetails = {
      "name": statusData?.employeeId?.name,
      "email": statusData?.employeeId?.email
    }

    switch (this.state.activeTab) {
      case 'Activities': return <ActivitiesContent userDetails={userDetails} statusData={statusData} surveyAns={surveyAns} />;
      case 'Email Replies': return <EmailsContent userDetails={userDetails} statusData={statusData} openPrintModal={this.openPrintModal} />;
      case 'PDF Files': return <PDFFilesContent userDetails={userDetails} uploadX={uploadX} />;
      default: return <ActivitiesContent userDetails={userDetails} />;
    }
  }

  /* FILE UPLOAD */
  handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (evt) => {
      const workbook = XLSX.read(evt.target.result, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      const formattedData = jsonData.map((row, index) => ({
        sno: index + 1,
        emp_id: row.emp_id || "",
        name: row.name || "",
        email: row.email || "",
        mobile: row.mobile || "",
        assigned: "No"
      }));

      this.setState((prev) => ({
        employees: [...prev.employees, ...formattedData]
      }));
    };

    reader.readAsBinaryString(file);
  };

  /* MODAL */
  toggleAssignModal = () => {
    this.setState((prev) => ({
      showAssignModal: !prev.showAssignModal,
      step: 1
    }));
  };

  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState((prev) => ({
      assignFormData: {
        ...prev.assignFormData,
        [name]: value
      }
    }));
  };

  nextStep = () => this.setState((prev) => ({ step: prev.step + 1 }));
  prevStep = () => this.setState((prev) => ({ step: prev.step - 1 }));

  /* MAIL SELECT */
  handleMailSelect = (id) => {
    this.setState((prev) => {
      const exists = prev.assignFormData.mailIdList.includes(id);

      return {
        assignFormData: {
          ...prev.assignFormData,
          mailIdList: exists
            ? prev.assignFormData.mailIdList.filter((m) => m !== id)
            : [...prev.assignFormData.mailIdList, id]
        }
      };
    });
  };

  /* EMPLOYEE SELECT */
  handleEmpSelect = (employeeId) => {
    this.setState((prev) => {
      const isSame = prev.assignFormData.employeeId === employeeId;

      return {
        assignFormData: {
          ...prev.assignFormData,
          employeeId: isSame ? null : employeeId
        }
      };
    });
  };

  /* FINAL SUBMIT */
  handleFinalAssign = () => {
    const { assignFormData } = this.state;
    console.log("FINAL:", assignFormData);

    const temp = {
      keyWord: "",
      pageNo: 1,
      size: 10
    };
    this.props.dispatch(dashboardActions.assignInsightEmpTasks(assignFormData, temp));

    this.toggleAssignModal();
  };

  onCloseAssignModal = () => {
    this.setState({ showAssignModal: false })
  }

  onEdit = (value) => {
    this.setState({ showUpdateModal: true, updateFormData: value.data })
  }

  handleSendReply = (mailId, replyText) => {
    const payload = {
      mailLibId: mailId,
      subject: "Re: Mail Response",
      body: `<p>${replyText}</p>`,
      // add other fields if your API needs
    };

    console.log("Reply Payload:", payload);

    // TODO: Replace with actual API
    // this.props.dispatch(dashboardActions.sendMailReply(payload));

  };

  goToBack = () => {
    this.props.history.push("/insightadmin/assign");
  }

  render() {
    const { step, assignFormData, showPrintModal } = this.state;
    const { dashboard } = this.props;

    const tabs = ['Activities', 'Email Replies', 'PDF Files'];

    const {
      getInsightEmpTaskByIdData = [],
      getInsightUploadsByAssignedIdData,
      getInsightSurveyByAssignedIdData = []
    } = dashboard;

    let updateFormData = getInsightEmpTaskByIdData;

    // console.log("getInsightEmpTaskByIdData------------------------>", getInsightEmpTaskByIdData)
    return (
      <>
        <LayoutWrap>
          <div className="flex flex-col h-screen bg-white textblack">

            {/* Header */}
            <div className="flex items-center gap-4 p-4 border-b border-gray-300 shrink-0">
              <button onClick={this.goToBack} className="p-2 rounded-full bg-indigo-100 text-indigo-600">
                <LuArrowLeft size={24} />
              </button>
              <h1 className="text-xl md:text-2xl font-semibold text-gray-800">
                Response Panel
              </h1>
            </div>

            {/* Tabs */}
            <div className="border-b border-gray-300 shrink-0">
              <nav className="flex md:px-8 px-4 md:space-x-10 space-x-6">
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => this.handleTabClick(tab)}
                    className={`py-4 px-1 border-b md:text-base text-sm font-medium ${this.state.activeTab === tab
                      ? "border-indigo-600 text-indigo-600"
                      : "border-transparent hover:text-indigo-600"
                      }`}
                  >
                    {tab}
                  </button>
                ))}
              </nav>
            </div>

            {/* 🔥 Content Area (IMPORTANT) */}
            <div className="flex-1 overflow-hidden">
              {this.renderContent(getInsightEmpTaskByIdData, getInsightUploadsByAssignedIdData, getInsightSurveyByAssignedIdData)}
            </div>

          </div>



        </LayoutWrap>

        {showPrintModal ?
          <>
            <PrintMailModal
              closeModal={this.closeModal}
              statusData={getInsightEmpTaskByIdData}
            />
          </> : null
        }

      </>
    );
  }
}

export default connect((state) => ({ dashboard: state.dashboard }))(
  AssignTask
);